import { useEffect, useRef } from 'react';
import { useFeatureFlags } from '@funtech-int/yango-shared';

import { useRequestIdManager } from '@/shared/hooks/useRequestIdManager';

import { featureFlagsScheme } from '../../../lib/featureFlags';
import { AppErrors } from '../../error-boundary-context/error-map/map';
import {
    useAddErrorData,
    useCurrentError,
    useHandleError,
} from '../../error-boundary-context/context';

export const useStreamsErrors = (onClose: () => void) => {
    const handleError = useHandleError();
    const addErrorData = useAddErrorData();
    const { name } = useCurrentError();
    const testErrorShown = useRef<boolean | null>(null);

    const requestIdManager = useRequestIdManager();
    const reqId = requestIdManager.requestId.root;

    const defaultPlayerError = useFeatureFlags(featureFlagsScheme).flags.get('defaultPlayerError');

    useEffect(() => {
        addErrorData({
            onErrorClose: onClose,
            sessionId: reqId,
        });
    }, [addErrorData, onClose, reqId]);

    useEffect(() => {
        if (defaultPlayerError && testErrorShown.current === null) {
            testErrorShown.current = true;
            handleError(defaultPlayerError as AppErrors, {});
        }
    }, [defaultPlayerError, handleError]);

    return name !== null;
};
